import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';
import Modal from 'react-bootstrap/Modal';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { withAuthorization } from '../Session';

class ProfilePage extends React.Component {
    _isMounted = false;
    state = {
        modalShow: false,
        delteItemId: '',
        alert: 0,
        alertMessage: '',
        flag: true,
        showAddEdit: true,
        ProfileUniqeID: '',
        FullName: '',
        DateOfBirth: '',
        EmailId: '',
        RegionalLanguage: '',
        PhoneNumber: '',
        SecondaryPhoneNumber: '',
        WhatsAppNumber: '',
        Education: '',
        Profession: '',
        AadharNumber: '',
        PanNumber: '',
        BankName: '',
        AccountNumber: '',
        AccountHolderName: '',
        IFSCCode: '',
        AccountType: '',
        Beneficiary: [],
        VirtualAccounts:[],
        primaryBank: '',

        NewBankName: '',
        NewAccountNumber: '',
        NewAccountHolderName: '',
        NewIFSCCode: '',
        NewAccountType: '',
        NewBankVerified: false,
        NewBankDetails: [],
        ShowFlashMessage: false,
        FlashMessage: '',
        HouseNumber: '',
        Area: '',
        City: '',
        District: '',
        PinCode: '',
        State: '',
        LastUpdatedTimeStamp: '',
        UpdatedBy: '',
        RequestedTimeStamp: '',
        profileDocId: '',
        totalBanks: 1,
        addNewBank: false,
        AllRegionalLanguage: [
            'Bengali',
            'English',
            'Gujarati',
            'Hindi',
            'Kannada',
            'Malayalam',
            'Marathi',
            'Oriya',
            'Punjabi',
            'Telugu'
        ],
        AllProfessions: [
            'CSC Center',
            'Money Transfer Point',
            'Fancy Shop',
            'Super Market',
            'Electronics Store',
            'Home Appliances Store',
            'Clothes Store',
            'Xerox Store',
            'Others'
        ],
        AllStates: [
            'Andhra Pradesh',
            'Arunachal Pradesh',
            'Assam',
            'Bihar',
            'Chhattisgarh',
            'Goa',
            'Gujarat',
            'Haryana',
            'Himachal Pradesh',
            'Jammu & Kashmir',
            'Jharkhand',
            'Karnataka',
            'Kerala',
            'Madhya Pradesh',
            'Maharashtra',
            'Manipur',
            'Meghalaya',
            'Mizoram',
            'Nagaland',
            'Odisha',
            'Punjab',
            'Rajasthan',
            'Sikkim',
            'TamilNadu',
            'Telangana',
            'Tripura',
            'Uttarakhand',
            'Uttar Pradesh',
            'West Bengal'
        ]
    };

    async componentDidMount() {
        this._isMounted = true;
        this.setState({ modalShow: false });
        this.getProfileDetail();
        //this.updateAllProfiles();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async updateAllProfiles() {
        /* 
        await RestServices.updateAllProfiles(localStorage.getItem('FirebaseToken'))
		.then(response => response.json())
		.then((responseData) => {
		//console.log('updateAllProfiles')
		//console.log(responseData)
		})
		.catch(err=>{
		    if(this._isMounted) {  this.setState({flag:false,alert:1,alertMessage:err.message})}
		});
	*/
    }

    async getProfileDetail() {
        this.setState({ flag: true });

        let dataRow = {
            UniqeID: this.props.user.ProfileUniqeID,
            UserRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role
        };
        //console.log(dataRow);

        await RestServices.getProfileDetail(
            localStorage.getItem('FirebaseToken'),
            dataRow
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData) {

                            let IFSC='';
                            let AccountNumber='';
                            let UPIAddress='';
                            let QRCode='';
                            if(responseData.data.VirtualAccounts){
                                let VirtualAccounts =responseData.data.VirtualAccounts
                
                                if(VirtualAccounts && VirtualAccounts['receivers']){
                                    let VirtualAccountsArray = VirtualAccounts['receivers']
                                    for (var i=0;i<VirtualAccountsArray.length;i++){   
                                    if(VirtualAccountsArray[i].ifsc){
                                        IFSC = VirtualAccountsArray[i].ifsc
                                    }
                                    if(VirtualAccountsArray[i].account_number){
                                        AccountNumber = VirtualAccountsArray[i].account_number
                                    }
                                    if(VirtualAccountsArray[i].address){
                                        UPIAddress = VirtualAccountsArray[i].address
                                    }
                                    }
                                }
                            }

                        if (this._isMounted) {
                            this.setState({
                                ...this.fieldsMapUtil(responseData.data),
                                Beneficiary: responseData.data.Beneficiary,
                                virtualAccounts: {IFSC:IFSC,AccountNumber:AccountNumber,UPIAddress:UPIAddress,QRCode:QRCode},
                                flag: false
                            });
                        }
                        
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    fieldsMapUtil = (data) => {
        let res = {};
        Object.keys(data).forEach((val) => {
            res = { ...res, [val]: data[val] };
        });
        res = {
            ...res,
            oldAccountNumber: data.AccountNumber,
            oldAccountHolderName: data.AccountHolderName,
            oldBankName: data.BankName,
            oldIFSCCode: data.IFSCCode,
            oldPanNumber: data.PanNumber,
            oldPhoneNumber: data.PhoneNumber,
            LastUpdatedTimeStamp: data.LastUpdatedTimeStamp,
            UpdatedBy: data.UpdatedBy,
            RequestedTimeStamp: data.RequestedTimeStamp
        };
        return res;
    };

    editProfileData = () => {
        let data = {
            Profession: this.state.Profession,
            DateOfBirth: this.state.DateOfBirth,
            FullName: this.state.FullName,
            PhoneNumber: '+91'+this.state.PhoneNumber.substring(this.state.PhoneNumber.length - 10),
            EmailId: this.state.EmailId,
            Education: this.state.Education,
            SecondaryPhoneNumber:
                '+91' + this.state.SecondaryPhoneNumber.replace('+91', ''),
            WhatsAppNumber: this.state.WhatsAppNumber
                ? '+91' + this.state.WhatsAppNumber.replace('+91', '')
                : '',
            RegionalLanguage: this.state.RegionalLanguage,
            HouseNumber: this.state.HouseNumber,
            City: this.state.City,
            Area: this.state.Area,
            PinCode: this.state.PinCode,
            State: this.state.State,
            District: this.state.District,
            AadharNumber: this.state.AadharNumber,
            AccountNumber: this.state.AccountNumber,
            AccountHolderName: this.state.AccountHolderName,
            BankName: this.state.BankName,
            IFSCCode: this.state.IFSCCode,
            AccountType: this.state.AccountType,
            PanNumber: this.state.PanNumber,
            RequestedTimeStamp: this.state.RequestedTimeStamp
                ? this.state.RequestedTimeStamp
                : dateFormatUtil(),
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName,
            profileDocId: this.state.profileDocId,
            UniqeID: this.props.user.ProfileUniqeID,
            UserRole: this.props.role
        };

        //console.log(data);
        if (this.state.oldPanNumber !== this.state.PanNumber) {
            data.ValidatePANAccount = true;
        } else {
            data.ValidatePANAccount = false;
        }

        var validationResult = this.validateForm(data);

        if (validationResult.isError) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: validationResult.errorMsg
                });
            }
        } else {
            if (this._isMounted) {
                this.setState({ flag: true, alert: 0, alertMessage: '' });
            }
            //console.log(data);
            RestServices.EditProfile(
                localStorage.getItem('FirebaseToken'),
                data
            )
                .then((response) => response.json())
                .then((responseData) => {
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        if (responseData.status) {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 2,
                                    alertMessage: 'Profile updated...'
                                });
                            }
                        } else {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 1,
                                    alertMessage: responseData.message
                                });
                            }
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        }
    };

    addNewBank = () => {
        this.setState({ addNewBank: !this.state.addNewBank });
    };

    removeBank = () => {
        this.setState({ addNewBank: !this.state.addNewBank });
    };

    validateNewBank = () => {
        let data = {
            AccountNumber: this.state.NewAccountNumber,
            IFSCCode: this.state.NewIFSCCode,
            ValidatePANAccount: false,
            ValidateBankAccount: true,
            addNewBeneficiary: false
        };

        //console.log(data);

        if (this._isMounted) {
            this.setState({
                NewBankVerified: false,
                flag: true,
                alert: 0,
                alertMessage: ''
            });
        }

        RestServices.addNewBankAccount(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData);
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData.status == 'SUCCESS') {
                        if (responseData.accountStatus == 'VALID') {
                            if (this._isMounted) {
                                this.setState({
                                    NewAccountHolderName:
                                        responseData.data.nameAtBank,
                                    NewBankName: responseData.data.bankName,
                                    NewBankVerified: true,
                                    flag: false,
                                    alert: 4,
                                    alertMessage: responseData.message
                                });
                            }
                        } else {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 5,
                                    alertMessage: responseData.message
                                });
                            }
                        }
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 5,
                                alertMessage: responseData.message
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 5,
                        alertMessage: err.message
                    });
                }
            });
    };

    addNewBankNow = () => {
        let data = {
            profileDocId: this.state.profileDocId,
            HouseNumber: this.state.HouseNumber,
            City: this.state.City,
            Area: this.state.Area,
            PinCode: this.state.PinCode,
            State: this.state.State,
            District: this.state.District,

            AccountNumber: this.state.NewAccountNumber,
            AccountHolderName: this.state.NewAccountHolderName,
            BankName: this.state.NewBankName,
            PhoneNumber: '+91' + this.state.PhoneNumber.replace('+91', ''),
            EmailId: this.state.EmailId,
            IFSCCode: this.state.NewIFSCCode,
            AccountType: this.state.NewAccountType,
            PanNumber: this.state.PanNumber,
            RequestedTimeStamp: dateFormatUtil(),
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName,
            isPrimary: true,
            ValidatePANAccount: false,
            ValidateBankAccount: false,
            addNewBeneficiary: true
        };

        if (this._isMounted) {
            this.setState({ flag: true, alert: 0, alertMessage: '' });
        }
        RestServices.addNewBankAccount(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData);
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 5,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData.status) {
                        let NewBeneficiaryList = this.state.Beneficiary;
                        NewBeneficiaryList.push(responseData.Beneficiary);

                        if (this._isMounted) {
                            this.setState({
                                Beneficiary: NewBeneficiaryList,
                                addNewBank: !this.state.addNewBank,
                                flag: false,
                                alert: 4,
                                alertMessage: responseData.message
                            });
                        }
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 5,
                                alertMessage: responseData.message
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 5,
                        alertMessage: err.message
                    });
                }
            });
    };

    resetPrimary = (itemId) => {
        if (this._isMounted) {
            this.setState({ primaryBank: itemId.value });
        }
        //console.log(itemId.value);
        let data = {
            profileDocId: this.state.profileDocId,
            beneId: itemId.value
        };

        //console.log(data);

        if (this._isMounted) {
            this.setState({ flag: true, alert: 0, alertMessage: '' });
        }
        RestServices.setPrimaryBank(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData);
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 5,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 4,
                            alertMessage: responseData.message
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 5,
                        alertMessage: err.message
                    });
                }
            });
    };

    deleteBank = (beneId) => {
        if (this._isMounted) {
            this.setState({
                delteItemId: beneId,
                modalShow: !this.state.modalShow
            });
        }
    };

    handleClose = () => {
        if (this._isMounted) {
            this.setState({
                delteItemId: '',
                modalShow: !this.state.modalShow
            });
        }
    };

    DeleteItem = () => {
        let beneId = this.state.delteItemId;

        let BeneficiaryList = [];
        //console.log('delete ' + beneId);
        //console.log(this.state.Beneficiary);

        this.state.Beneficiary.some(function (el) {
            if (el.beneId !== beneId) {
                BeneficiaryList.push(el);
            }
        });

        let data = {
            profileDocId: this.state.profileDocId,
            beneId: beneId,
            PhoneNumber: '+91' + this.state.PhoneNumber.replace('+91', ''),
            EmailId: this.state.EmailId,
            PanNumber: this.state.PanNumber,
            BeneficiaryList: BeneficiaryList
        };
        //console.log(data);
        RestServices.deleteBank(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData);
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 5,
                            alertMessage: responseData.error,
                            modalShow: !this.state.modalShow
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            Beneficiary: BeneficiaryList,
                            modalShow: !this.state.modalShow
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 5,
                        alertMessage: err.message,
                        modalShow: !this.state.modalShow
                    });
                }
            });
    };

    copyToClipboard = (rowData, FlashMessageString) => {
        
        var textField = document.createElement('textarea');
        textField.innerText = rowData;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        if (this._isMounted) {
            this.setState({
                ShowFlashMessage: true,
                FlashMessage: FlashMessageString
            });
            setTimeout(() => {
                this.setState({ ShowFlashMessage: false, FlashMessage: '' });
            }, 5000);
        }
    };

    render() {
        let totalBanks = this.state.Beneficiary;
        return (
            <Container className="no_padding">
                {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}
                
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                <Row>
                    <Col>
                        <h5>Personal Details {this.state.modalShow}</h5>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="FullName"
                            value={this.state.FullName}
                            onChange={this.onChangeValues}
                            required
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Date of Birth</Form.Label>
                        <Form.Control
                            type="date"
                            name="DateOfBirth"
                            value={this.state.DateOfBirth}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Email Id</Form.Label>
                        <Form.Control
                            type="text"
                            name="EmailId"
                            value={this.state.EmailId}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Regional Language</Form.Label>
                        <Autocomplete
                            name="RegionalLanguage"
                            value={this.state.RegionalLanguage}
                            onChange={(event, newValue) => {
                                this.setState({ RegionalLanguage: newValue });
                            }}
                            id="user_profession"
                            options={this.state.AllRegionalLanguage.map(
                                (arr) => arr
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Education</Form.Label>
                        <Form.Control
                            type="text"
                            name="Education"
                            value={this.state.Education}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="PhoneNumber"
                            value={this.state.PhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Alternate Mobile Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="SecondaryPhoneNumber"
                            value={this.state.SecondaryPhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>WhatsApp Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="WhatsAppNumber"
                            value={this.state.WhatsAppNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Profession</Form.Label>
                        <Autocomplete
                            name="Profession"
                            value={this.state.Profession}
                            onChange={(event, newValue) => {
                                this.setState({ Profession: newValue });
                            }}
                            id="user_profession"
                            options={this.state.AllProfessions.map(
                                (arr) => arr
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Aadhar Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="AadharNumber"
                            value={this.state.AadharNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Row>
                    <Col>
                        <h5>Residential Address</h5>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>House Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="HouseNumber"
                            value={this.state.HouseNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Area</Form.Label>
                        <Form.Control
                            type="text"
                            name="Area"
                            value={this.state.Area}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>City/Town</Form.Label>
                        <Form.Control
                            type="text"
                            name="City"
                            value={this.state.City}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Pincode</Form.Label>
                        <Form.Control
                            type="text"
                            name="PinCode"
                            value={this.state.PinCode}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>District</Form.Label>
                        <Form.Control
                            type="text"
                            name="District"
                            value={this.state.District}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>

                        <Autocomplete
                            name="State"
                            value={this.state.State}
                            onChange={(event, newValue) => {
                                this.setState({ State: newValue });
                            }}
                            id="user_State"
                            options={this.state.AllStates.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                <Row>
                    <Col>
                        <h5>Virtual Accounts</h5>
                        <p>Please contact admin to update Virtual Accounts Details</p>
                        <hr />
                    </Col>
                </Row>
                

                {this.state.virtualAccounts &&<div>
                                    <Form.Row style={{ width: '30%' }}>
                                        <Form.Group as={Col}>
                                        <Form.Label>
                                        UPI Address
                                        </Form.Label>
                                        <Form.Control
                                        disabled
                                        value={this.state.virtualAccounts.UPIAddress}
                                        type="text"
                                        />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row style={{ width: '3%',padding: '0' }}>
                                        {this.state.virtualAccounts.UPIAddress &&<img onClick={(e) =>
                                            this.copyToClipboard(
                                                this.state.virtualAccounts.UPIAddress,
                                                'UPIAddress copied to clipboard'
                                            )
                                        }className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                    </Form.Row>

                                    <Form.Row style={{ width: '30%' }}>
                                        <Form.Group as={Col}>
                                        <Form.Label>
                                        IFSC
                                        </Form.Label>
                                        <Form.Control
                                        disabled
                                        value={this.state.virtualAccounts.IFSC}
                                        type="text"
                                        />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row style={{ width: '3%',padding: '0' }}>
                                        {this.state.virtualAccounts.IFSC &&<img onClick={(e) =>
                                            this.copyToClipboard(
                                                this.state.virtualAccounts.IFSC,
                                                'IFSC copied to clipboard'
                                            )
                                        } className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                    </Form.Row>


                                    <Form.Row style={{ width: '30%' }}>
                                        <Form.Group as={Col}>
                                        <Form.Label>Account #</Form.Label>
                                        <Form.Control
                                        disabled
                                        value={this.state.virtualAccounts.AccountNumber}
                                        type="text"
                                        />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row style={{ width: '3%',padding: '0' }}>
                                        {this.state.virtualAccounts.AccountNumber &&<img onClick={(e) =>
                                            this.copyToClipboard(
                                                this.state.virtualAccounts.AccountNumber,
                                                'AccountNumber copied to clipboard'
                                            )
                                        } className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                    </Form.Row>

                                </div>}
                              
                        
       


                <Row>
                    <Col>
                        <h5>Banking Details</h5>
                        <p>Please contact admin to update Banking Details</p>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>PAN Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="PanNumber"
                            value={this.state.PanNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                {this.state.Beneficiary && (
                    <div>
                        {this.state.Beneficiary.map((c, index) => {
                            let primaryBank = this.state.primaryBank;
                            if (c.isPrimary) {
                                primaryBank = c.beneId;
                            }

                            return (
                                <div key={index} id={index}>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>
                                                Account Holder Name
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.AccountHolderName}
                                                name="AccountHolderName"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>Bank Name</Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.BankName}
                                                name="BankName"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>
                                                Account Number
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.AccountNumber}
                                                name="AccountNumber"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>IFSC Code</Form.Label>
                                            <Form.Control
                                                disabled
                                                value={c.IFSCCode}
                                                name="IFSCCode"
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label></Form.Label>
                                            <input
                                                type="radio"
                                                value={c.beneId}
                                                checked={
                                                    this.state.primaryBank ===
                                                    c.beneId
                                                }
                                                name="PrimaryBank"
                                                onChange={(e) =>
                                                    this.resetPrimary(
                                                        e.currentTarget
                                                    )
                                                }
                                            />{' '}
                                            Set as Primary
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row style={{ textAlign: 'right' }}>
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            onClick={(e) =>
                                                this.deleteBank(c.beneId)
                                            }
                                        >
                                            Delete
                                        </Button>
                                    </Form.Row>

                                    <hr />
                                </div>
                            );
                        })}
                    </div>
                )}

                {this.state.addNewBank && (
                    <div>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Account Number</Form.Label>
                                <Form.Control
                                    value={this.state.NewAccountNumber}
                                    name="NewAccountNumber"
                                    type="text"
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>IFSC Code</Form.Label>
                                <Form.Control
                                    value={this.state.NewIFSCCode}
                                    name="NewIFSCCode"
                                    type="text"
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                        </Form.Row>

                        {this.state.NewBankVerified && (
                            <div>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>
                                            Account Holder Name
                                        </Form.Label>
                                        <Form.Control
                                            value={
                                                this.state.NewAccountHolderName
                                            }
                                            name="NewAccountHolderName"
                                            type="text"
                                            onChange={this.onChangeValues}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>Bank Name</Form.Label>
                                        <Form.Control
                                            value={this.state.NewBankName}
                                            name="NewBankName"
                                            type="text"
                                            onChange={this.onChangeValues}
                                        />
                                    </Form.Group>
                                </Form.Row>
                            </div>
                        )}
                        <hr />
                    </div>
                )}

                <Form.Row></Form.Row>
                <Form.Row style={{ textAlign: 'right' }}>
                    {this.state.addNewBank && (
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={this.removeBank}
                        >
                            Cancel
                        </Button>
                    )}

                    {this.state.addNewBank && !this.state.NewBankVerified && (
                        <Button
                            style={{ marginLeft: '1rem' }}
                            variant="primary"
                            type="submit"
                            onClick={this.validateNewBank}
                        >
                            Validate
                        </Button>
                    )}

                    {this.state.addNewBank && this.state.NewBankVerified && (
                        <Button
                            style={{ marginLeft: '1rem' }}
                            variant="primary"
                            type="submit"
                            onClick={this.addNewBankNow}
                        >
                            Save Bank
                        </Button>
                    )}

                    {!this.state.addNewBank && (
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={this.addNewBank}
                        >
                            Add Bank
                        </Button>
                    )}
                </Form.Row>

                <hr />
                {this.state.alert === 5 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 4 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                <Form.Row>
                    {!this.state.addNewBank && (
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={this.editProfileData}
                        >
                            Update Profile
                        </Button>
                    )}
                </Form.Row>

                <Modal
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            Are you sure you want to delete this Bank Account?
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.DeleteItem}>
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }

    validateForm = () => {
        let isError = false;
        let errorMsg = '';
        if (this.state.FullName == '' || this.state.PhoneNumber == '') {
            isError = true;
            errorMsg = errorMsg + ' Please enter all the values.';
        }

        let PhoneNumber = this.state.PhoneNumber.replace('+91', '');
        let SecondaryPhoneNumber = this.state.SecondaryPhoneNumber.replace(
            '+91',
            ''
        );

        if (PhoneNumber.length != 10 || !PhoneNumber.match('[0-9]{10}')) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid Primary Phone Number.';
        }

        if (
            SecondaryPhoneNumber.length != 10 ||
            !SecondaryPhoneNumber.match('[0-9]{10}')
        ) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid Secondary Phone Number.';
        }

        if (PhoneNumber == SecondaryPhoneNumber) {
            isError = true;
            errorMsg =
                errorMsg +
                ' Primary Number and Secondary Number cannot be the same.';
        }

        if (
            !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                this.state.EmailId
            )
        ) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid Personal EmailId.';
        }

        var reurndate = [];
        reurndate.isError = isError;
        reurndate.errorMsg = errorMsg;
        return reurndate;
    };
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(ProfilePage);
